import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import  ProgressMenu  from './components/presentational/progress_menu.jsx';

class FlowLayout extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    return (
      <div className="flow-layout">
        <ProgressMenu
          active={this.props.progress.currentIndex}
          steps={this.props.progress.flow}
          disabledSteps={undefined}
        />
        {this.props.children}
      </div>
    );
  }
}

function mapStateToProps( { progress } ) {
  return { progress };
}

export default connect(mapStateToProps, null)(FlowLayout);
